module.exports = __webpack_public_path__ + "img/external.8d3a41c234129241f192c84509289b80.png";